import { COLORS } from '@btime/constants'
import { compose, prop } from 'ramda'
import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../components/presentation/Text'
import { usePlace } from './_load/PlaceLoader'
import DeletedTag from '../../../components/helpers/DeletedTag'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation()
  const place = usePlace()

  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(place)

  return (
    <>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <FlexCol flex={1}>
          <Title size="h4" strong color={COLORS.dark2} noMargin>
            {place.name}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('createdAt')} {createdAt}
          </SmallText>
        </FlexCol>

        <FlexCol flex={1}></FlexCol>

        <FlexCol>
          <DeletedTag entity={place} />
        </FlexCol>
        <FlexCol>
          <RefetchingIndicator />
        </FlexCol>
      </FlexGrid>

      <Separator weight={6} />

      <TabsMenu t={t} />
    </>
  )
}

export default ModalHeader
